
export default {
  name: 'BlogArticleTags',
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
}
